module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "step4-form",
    style: ({
      minHeight: (_vm.screenHeight - 85) + 'px'
    })
  }, [(this.$route.query.yanse == 1) ? _c('div', {
    staticClass: "step-form__step-num2"
  }, [_vm._v("4/5")]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 2) ? _c('div', {
    staticClass: "step-form__step-num"
  }, [_vm._v("4/5")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__main"
  }, [_c('h1', {
    staticClass: "step-form__title"
  }, [_vm._v(_vm._s(this.$route.query.productName) + "-资料附件确认")]), _vm._v(" "), _vm._l((_vm.fileTypeLists.itemFiles), function(item, index) {
    return _c('div', {
      staticClass: "step-form__file-list file-list"
    }, [_c('h6', {
      staticClass: "file-list__item-title"
    }, [_c('span', [_vm._v(_vm._s(("" + (item.name) + (item.isMustUpload === '1' ? '（必传）' : ''))))])]), _vm._v(" "), _c('div', {
      staticClass: "file-list__item-content"
    }, [_c('ul', {
      staticClass: "file-list__item-list"
    }, [_vm._l((_vm.fileLists.itemFiles[index].idsarr), function(file) {
      return [(/\.pdf|\.doc|\.rar|\.zip|\.7z/g.test(file.fileName)) ? _c('li', {
        class: ['file-list__item-preview', ("file-list__" + (file.fileName.substr(file.fileName.lastIndexOf('.')+1)) + "-preview")],
        on: {
          "click": function($event) {
            if ($event.target !== $event.currentTarget) { return null; }
            return _vm.showPreviewImage(file.fileId, false)
          }
        }
      }, [_c('div', {
        staticClass: "file-list__item-delete",
        on: {
          "click": function($event) {
            return _vm.deleteUploadedFile(item.filesId, file)
          }
        }
      }, [_c('i', {
        staticClass: "el-icon-close"
      })]), _vm._v(" "), _c('div', {
        staticClass: "file-list__file-name"
      }, [_vm._v(_vm._s(file.fileName))])]) : _c('li', {
        staticClass: "file-list__item-preview"
      }, [_c('img', {
        attrs: {
          "src": (_vm.ajaxBaseUrl + "/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=" + (file.fileId) + "&tokenId=" + (_vm.userInfo.token))
        },
        on: {
          "click": function($event) {
            return _vm.showPreviewImage(file.fileId, true)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "file-list__item-delete",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.deleteUploadedFile(item.filesId, file)
          }
        }
      }, [_c('i', {
        staticClass: "el-icon-close"
      })])])]
    }), _vm._v(" "), _c('li', {
      staticClass: "file-list__select-file picker",
      on: {
        "mousedown": function($event) {
          return _vm.changeFileType(item.filesId)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-plus"
    }), _vm._v(" "), _c('div', {
      staticClass: "file-list__select-file-title"
    }, [_vm._v(_vm._s(item.name))])])], 2)])])
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "br_gid"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "step-form__btn-container"
  }, [(this.$route.query.yanse == 1) ? _c('button', {
    staticClass: "step-form__btn-prev2",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("上一步")]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 1) ? _c('button', {
    staticClass: "step-form__btn-next2",
    on: {
      "click": _vm.goNext
    }
  }, [_vm._v("下一步")]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 2) ? _c('button', {
    staticClass: "step-form__btn-prev",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("上一步")]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 2) ? _c('button', {
    staticClass: "step-form__btn-next",
    on: {
      "click": _vm.goNext
    }
  }, [_vm._v("下一步")]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 3) ? _c('button', {
    staticClass: "step-form__btn-next",
    on: {
      "click": _vm.submitFile
    }
  }, [_vm._v("提交")]) : _vm._e()])], 2), _vm._v(" "), _c('el-dialog', {
    staticClass: "file-preview-modal",
    attrs: {
      "title": "图片预览",
      "visible": _vm.filePreview.show,
      "before-close": _vm.hidePreviewImage,
      "close-on-click-modal": false
    }
  }, [_c('div', {
    staticClass: "file-preview-modal__body"
  }, [_c('img', {
    attrs: {
      "src": _vm.filePreview.src,
      "alt": "图片预览"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog__footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "dialog__footer__confirm-btn",
    on: {
      "click": _vm.hidePreviewImage
    }
  }, [_vm._v("确定")])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "progressDialog",
    attrs: {
      "title": " ",
      "visible": _vm.isShowProgress,
      "size": "tiny",
      "top": "20%",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.isShowProgress = $event
      }
    }
  }, [_c('el-progress', {
    staticClass: "upload_progress",
    attrs: {
      "text-inside": true,
      "stroke-width": 18,
      "percentage": _vm.progress
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "tb1",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "border": "1"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "title"
  }, [_vm._v("设备指纹")]), _c('td', {
    attrs: {
      "id": "gid"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "title"
  }, [_vm._v("设备流水号")]), _c('td', {
    attrs: {
      "id": "console"
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sec1"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sec2"
    }
  }), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('button', {
    staticClass: "o BR_ATF_ACTION",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "test"
    }
  }, [_vm._v("button")]), _vm._v(" "), _c('button', {
    staticClass: "loginBtn",
    attrs: {
      "onclick": "loginHandler()"
    }
  }, [_vm._v("登录触发")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb016c98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/applyLoan/Step4.vue
// module id = 1103
// module chunks = 1